import InterviewAttendees from './InterviewAttendees';
export default InterviewAttendees;